import { render, staticRenderFns } from "./TableGrade.vue?vue&type=template&id=4af217b3&"
import script from "./TableGrade.vue?vue&type=script&lang=js&"
export * from "./TableGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports